<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Company Menu" @click="$router.push('/company')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" fab small @click="showAdd">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1 section-card">
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>                    
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? [] : header"
                    :items="annoucements_filtered" 
                    :loading="loading"
                    :hide-headers="isMobile"
                >
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="header.length" class="pa-1">
                                <v-card class="elevation-1" @click="showEdit(props.item)">
                                    <v-toolbar flat height="42">
                                        <v-chip small class="user-chip-container" :style="`background-color:${props.item.backgroundColor}`">
                                            <span class="white--text">{{ props.item.categoryName }}</span>
                                        </v-chip>
                                        <v-spacer></v-spacer>
                                        <div :class="props.item.statusColor">{{ props.item.status }}</div>
                                    </v-toolbar>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5 mb-1">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Type</div>
                                                    <div>{{ props.item.typeName }}</div>
                                                </v-flex>
                                                <v-flex xs8>
                                                    <div class="caption grey--text text--darken-1">Recipients</div>
                                                    <div v-if="props.item.isAllTeamsSelected">All Teams</div>
                                                    <team-chips v-else :teams="props.item.teams"></team-chips>   
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Display Date</div>
                                                    <div :title="$moment(props.item.displayStartDate).format('MMM DD, YYYY h:mm a')">{{ props.item.displayStartDate | moment('MMM DD h:mma') }}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Start Date</div>
                                                    <div :title="$moment(props.item.effectiveDate).format('MMM DD, YYYY h:mm a')">{{ props.item.effectiveDate | moment('MMM DD h:mma') }}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">End Date</div>
                                                    <div :title="$moment(props.item.expirationDate).format('MMM DD, YYYY h:mm a')">{{ props.item.expirationDate | moment('MMM DD h:mma') }}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="caption grey--text text--darken-1">Details</div>
                                                    <div>{{ props.item.details }}</div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>
                        
                        <!-- desktop view -->
                        <tr v-else @click="showEdit(props.item)" title="Click to edit" class="clickable">
                            <td>
                                <v-chip small class="user-chip-container" :style="`background-color:${props.item.backgroundColor}`">
                                    <span class="white--text">{{ props.item.categoryName }}</span>
                                </v-chip>
                            </td>
                            <td>{{ props.item.typeName }}</td>
                            <td>{{ props.item.details }}</td>
                            <td>
                                <span v-if="props.item.isAllTeamsSelected">All Teams</span>
                                <team-chips v-else :teams="props.item.teams"></team-chips>                             
                            </td>
                            <td :title="$moment(props.item.displayStartDate).format('MMM DD, YYYY h:mm a')">{{ props.item.displayStartDate | moment('MMM DD h:mma') }}</td>
                            <td :title="$moment(props.item.effectiveDate).format('MMM DD, YYYY h:mm a')">{{ props.item.effectiveDate | moment('MMM DD h:mma') }}</td>
                            <td :title="$moment(props.item.expirationDate).format('MMM DD, YYYY h:mm a')">{{ props.item.expirationDate | moment('MMM DD h:mma') }}</td>
                            <td>
                                <span :class="props.item.statusColor">{{ props.item.status }}</span>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogAddEdit" persistent width="900">
            <add-edit ref="refAddEdit" :dialogAddEdit.sync="dialogAddEdit" @send="getPulicNotifications"></add-edit>
        </v-dialog>
    </v-layout> 
</template>

<script>

import companyAnnouncementsApi from '@/api/company-announcements'
import awsS3Helper from '@/helpers/aws-s3'

export default {     
    name: 'CompanyAnnouncements',
    metaInfo: {
        title: 'Company Announcements',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Announcements' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'team-chips': () => import("@/components/Common/TeamsChip"),
        'add-edit': ()=> import('@/components/CompanyAnnouncements/AddEditCompanyAnnouncement')
    },
    data () {
        return {
            awsS3Helper,
            header: [
                {text:'Category', align: 'left', value:'categoryName', width:'10%', sortable:true},
                {text:'Type', align: 'left', value:'typeName', width:'10%', sortable:true},
                {text:'Details', align: 'left', value:'details',  width:'20%', sortable:true},
                {text:'Recipients', align: 'left', value:'teams',  width:'10%', sortable:true},
                {text:'Display Date', align: 'left', value:'displayStartDate',  width:'10%', sortable:true},
                {text:'Start Date', align: 'left', value:'effectiveDate',  width:'10%', sortable:true},
                {text:'End Date', align: 'left', value:'expirationDate',  width:'10%', sortable:true},
                {text:'Status', align: 'left', value:'status',  width:'10%', sortable:true},
            ],
            search: null,
            error: false,
            errorMessage: '',
            loading: false,
            dialogAddEdit: false,
            annoucements: []
        }
    },
    methods: {
        showEdit(data) {
            this.$refs.refAddEdit.setEdit(data)
            this.dialogAddEdit = true
        },
        showAdd() {
            this.$refs.refAddEdit.setAdd()
            this.dialogAddEdit = true
        },
        async getPulicNotifications() {
            try {
                this.loading = true
                const response = await companyAnnouncementsApi.getAll()
                if (response && response.status == 200) {
                    this.annoucements = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'Company Announcements',
            headerPageTitle: ''
        })

        this.getPulicNotifications()
    },
    computed: {
        annoucements_filtered() {
            var temp = this.annoucements

            //search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase();

                temp = temp.filter(item => {
                    const categoryNameMatch = item.categoryName.toLowerCase().includes(searchLower)                    
                    const typeNameMatch = item.typeName.toLowerCase().includes(searchLower)       
                    const detailsMatch = item.details.toLowerCase().includes(searchLower)                 
                    const displayStartDateMatch = item.displayStartDate.includes(searchLower)
                    const effectiveDateMatch = item.effectiveDate.includes(searchLower)
                    const expirationDateMatch = item.expirationDate.includes(searchLower)
                    const statusMatch = item.status.includes(searchLower)

                    const teamsMatch = Array.isArray(item.teams)
                        ? item.teams.join(', ').toLowerCase().includes(searchLower)
                        : false

                    return categoryNameMatch || 
                            typeNameMatch || 
                            detailsMatch || 
                            displayStartDateMatch || 
                            effectiveDateMatch ||
                            expirationDateMatch ||
                            statusMatch ||
                            teamsMatch 
                })
            }
            return temp
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>
<style scoped>
.section-card {
    margin-top:10px;
}
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>